export default "__VITE_ASSET__D_V9U$P2__"